import React from "react";
import ReactDOM from "react-dom";
import classNames from "classnames";
import {observer} from "mobx-react";
import {DrawerBodyBox} from "./boxes/body/drawer-body.box";
import {DrawerContentBox} from './boxes/content/drawer-content.box';
import {DrawerSpinnerComponent} from "./drawer-spinner.component";
import {withServices} from "../../react-hooks/with-services";
import {ComponentServicesPick} from "../../services/component-services-pick";

export interface RightDrawerComponentProps extends ComponentServicesPick<'drawer' | 'dom'> {
  className?: string;
}

const ComponentBody: React.FC<RightDrawerComponentProps> = observer((props) => {
  const rightDrawer = props.drawer.right;
  const renderContent = () => {
    const lastVisibleDrawerItemIndex = rightDrawer.getLastVisibleDrawerItemIndex();
    const isSpinnerVisible = rightDrawer.isSpinnerVisible;
    return rightDrawer.currentContent.map((content, index) => {
      return (
          <DrawerContentBox key={content.id} id={content.id} visible={index === lastVisibleDrawerItemIndex && !isSpinnerVisible}>
            {content.render()}
          </DrawerContentBox>
      )
    });
  }

  const renderSpinner = () => {
    if(rightDrawer.isSpinnerVisible) {
      return (
          <DrawerSpinnerComponent/>
      )
    }

    return null;
  }

  const renderDrawer = () => {
    let zIndex = rightDrawer.getOverlayZIndex();
    let isBlurBackground = rightDrawer.hasBlurBackground;

    return (

        <DrawerBodyBox zIndex={zIndex} isBlurBackground={isBlurBackground} className={classNames(props.className, {
          open: rightDrawer.isOpen
        })}>
          {renderContent()}
          {renderSpinner()}
        </DrawerBodyBox>
    );
  }

  return ReactDOM.createPortal(renderDrawer(), props.dom.body);

})


export const RightDrawerComponent = withServices(ComponentBody, ["drawer", "dom"]);